// extracted by mini-css-extract-plugin
var _1 = "PostTitleWithIcons-module__icon--Xk_3w";
var _2 = "PostTitleWithIcons-module__muted--Vyn_z";
var _3 = "PostTitleWithIcons-module__regular--kBY9T";
var _4 = "PostTitleWithIcons-module__small--ECwUd";
export { _1 as "icon", _2 as "muted", _3 as "regular", _4 as "small" }
